import { render, staticRenderFns } from "./DashboardAdminTab2.vue?vue&type=template&id=273a64e2&scoped=true"
import script from "./DashboardAdminTab2.vue?vue&type=script&lang=js"
export * from "./DashboardAdminTab2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273a64e2",
  null
  
)

export default component.exports